module.exports = __webpack_public_path__ + "img/bg-shorten-desktop.a82de60e.svg";